import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface Notification {
  id: number;
  name: string;
  initial: string;
  price: string;
}
const notifications: Omit<Notification, 'id'>[] = [{
  name: 'Valentina',
  initial: 'R.',
  price: '$12.97'
}, {
  name: 'Santiago',
  initial: 'M.',
  price: '$15.00'
}, {
  name: 'Isabella',
  initial: 'G.',
  price: '$9.97'
}, {
  name: 'Mateo',
  initial: 'L.',
  price: '$18.50'
}, {
  name: 'Camila',
  initial: 'P.',
  price: '$11.47'
}, {
  name: 'Sebastián',
  initial: 'V.',
  price: '$14.97'
}, {
  name: 'Sofía',
  initial: 'T.',
  price: '$8.97'
}, {
  name: 'Diego',
  initial: 'H.',
  price: '$22.00'
}, {
  name: 'Lucía',
  initial: 'C.',
  price: '$16.50'
}, {
  name: 'Alejandro',
  initial: 'S.',
  price: '$13.97'
}, {
  name: 'Martina',
  initial: 'F.',
  price: '$19.97'
}, {
  name: 'Nicolás',
  initial: 'D.',
  price: '$10.47'
}, {
  name: 'Victoria',
  initial: 'B.',
  price: '$17.50'
}, {
  name: 'Gabriel',
  initial: 'N.',
  price: '$12.00'
}, {
  name: 'Valeria',
  initial: 'A.',
  price: '$20.97'
}, {
  name: 'Daniel',
  initial: 'O.',
  price: '$14.50'
}, {
  name: 'Emma',
  initial: 'J.',
  price: '$11.97'
}, {
  name: 'Lucas',
  initial: 'Q.',
  price: '$24.00'
}, {
  name: 'Renata',
  initial: 'E.',
  price: '$7.97'
}, {
  name: 'Andrés',
  initial: 'K.',
  price: '$16.97'
}, {
  name: 'Paula',
  initial: 'I.',
  price: '$13.50'
}, {
  name: 'Miguel',
  initial: 'U.',
  price: '$21.50'
}, {
  name: 'Carolina',
  initial: 'W.',
  price: '$9.47'
}, {
  name: 'Fernando',
  initial: 'Y.',
  price: '$18.97'
}, {
  name: 'Daniela',
  initial: 'Z.',
  price: '$15.50'
}, {
  name: 'Ricardo',
  initial: 'X.',
  price: '$23.00'
}, {
  name: 'Gabriela',
  initial: 'Ñ.',
  price: '$6.97'
}, {
  name: 'Roberto',
  initial: 'R.',
  price: '$25.00'
}, {
  name: 'Ana',
  initial: 'M.',
  price: '$10.97'
}, {
  name: 'Carlos',
  initial: 'L.',
  price: '$19.50'
}, {
  name: 'Mariana',
  initial: 'G.',
  price: '$8.47'
}, {
  name: 'Joaquín',
  initial: 'P.',
  price: '$14.00'
}, {
  name: 'Catalina',
  initial: 'S.',
  price: '$17.97'
}, {
  name: 'Emilio',
  initial: 'T.',
  price: '$11.50'
}, {
  name: 'Fernanda',
  initial: 'V.',
  price: '$20.50'
}, {
  name: 'Rodrigo',
  initial: 'H.',
  price: '$9.97'
}, {
  name: 'Julieta',
  initial: 'C.',
  price: '$16.00'
}, {
  name: 'Maximiliano',
  initial: 'D.',
  price: '$22.50'
}, {
  name: 'Antonella',
  initial: 'B.',
  price: '$13.00'
}, {
  name: 'Benjamín',
  initial: 'F.',
  price: '$18.00'
}];
export function SocialProofNotification() {
  const [currentNotification, setCurrentNotification] = useState<Notification | null>(null);
  const [usedIndices, setUsedIndices] = useState<Set<number>>(new Set());
  const [availableIndices, setAvailableIndices] = useState<number[]>(notifications.map((_, i) => i));
  useEffect(() => {
    const showNotification = () => {
      if (availableIndices.length === 0) {
        setUsedIndices(new Set());
        setAvailableIndices(notifications.map((_, i) => i));
        return;
      }
      const randomIndex = Math.floor(Math.random() * availableIndices.length);
      const notificationIndex = availableIndices[randomIndex];
      const notification = notifications[notificationIndex];
      setCurrentNotification({
        id: Date.now(),
        ...notification
      });
      setAvailableIndices(prev => prev.filter((_, i) => i !== randomIndex));
      setUsedIndices(prev => new Set([...prev, notificationIndex]));
      setTimeout(() => {
        setCurrentNotification(null);
      }, 6000);
      const minDelay = 6 * 60 * 1000;
      const maxDelay = 8 * 60 * 1000;
      const unlockDelay = Math.random() * (maxDelay - minDelay) + minDelay;
      setTimeout(() => {
        setUsedIndices(prev => {
          const newSet = new Set(prev);
          newSet.delete(notificationIndex);
          return newSet;
        });
        setAvailableIndices(prev => [...prev, notificationIndex]);
      }, unlockDelay);
    };
    const minInterval = 8 * 1000;
    const maxInterval = 10 * 1000;
    const randomInterval = Math.random() * (maxInterval - minInterval) + minInterval;
    const timer = setTimeout(() => {
      showNotification();
    }, randomInterval);
    return () => clearTimeout(timer);
  }, [currentNotification, availableIndices]);
  const handleClose = () => {
    setCurrentNotification(null);
  };
  return <div className="fixed bottom-6 left-6 z-50 pointer-events-none" data-id="element-233">
      <AnimatePresence data-id="element-234">
        {currentNotification && <motion.div key={currentNotification.id} initial={{
        opacity: 0,
        y: 50,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="bg-gradient-to-br from-[#3b1858] to-[#2d1244] rounded-xl shadow-2xl p-4 max-w-sm pointer-events-auto relative overflow-hidden" data-id="element-235">
            <div className="absolute inset-0 bg-gradient-to-r from-[#e6b54a]/10 to-transparent pointer-events-none" data-id="element-236" />
            <div className="flex items-start gap-3 relative" data-id="element-237">
              <div className="flex-shrink-0 w-12 h-16 rounded overflow-hidden shadow-lg" data-id="element-238">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3HuJLZ7npDPgAyGAZZCTtY/PortadaLibro.png" alt="El Secreto de la Abundancia" className="w-full h-full object-cover" data-id="element-239" />
              </div>
              <div className="flex-1 pt-1" data-id="element-240">
                <div className="flex items-start justify-between gap-2 mb-1" data-id="element-241">
                  <div className="flex items-center gap-2" data-id="element-242">
                    <div className="w-2 h-2 bg-[#4ade80] rounded-full shadow-lg shadow-[#4ade80]/50 flex-shrink-0" data-id="element-243" />
                    <p className="text-xs font-medium text-[#e6b54a] uppercase tracking-wide" data-id="element-244">
                      Compra Reciente
                    </p>
                  </div>
                  <button onClick={handleClose} className="text-gray-400 hover:text-white transition-colors" data-id="element-245">
                    <X className="w-4 h-4" data-id="element-246" />
                  </button>
                </div>
                <p className="text-white font-semibold mb-1" data-id="element-247">
                  {currentNotification.name} {currentNotification.initial}
                </p>
                <p className="text-sm text-gray-300" data-id="element-248">
                  Edición Digital •{' '}
                  <span className="text-[#e6b54a] font-semibold" data-id="element-249">
                    {currentNotification.price}
                  </span>
                </p>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}